import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-03-tarun-mehta-guest.webp";
import ThumbImg from "../../assets/images/conversations/003.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: tm-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .tm-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .tm-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .tm-hero { padding-top: 60px; padding-bottom: 60px; }
  .tm-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .tm-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .tm-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .tm-hero__title.tm-visible { opacity: 1; transform: translateY(0); }
  .tm-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .tm-hero__spotify.tm-visible { opacity: 1; transform: translateY(0); }
  .tm-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .tm-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .tm-hero__right.tm-visible { opacity: 1; transform: translateY(0); }

  .tm-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .tm-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .tm-yt-thumb:hover img { opacity: 0.85; }
  .tm-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .tm-yt-thumb__play img { width: 40px; height: 44px; }
  .tm-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .tm-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .tm-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .tm-body.tm-visible { opacity: 1; transform: translateY(0); }
  .tm-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .tm-body__para:last-child { margin-bottom: 0; }

  .tm-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .tm-guest.tm-visible { opacity: 1; transform: translateY(0); }
  .tm-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .tm-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .tm-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .tm-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .tm-inner { padding-left: 32px; padding-right: 32px; }
    .tm-hero { padding-top: 32px; padding-bottom: 48px; }
    .tm-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .tm-hero__title { font-size: 24px; }
    .tm-hero__left { gap: 16px; }
    .tm-guest__title { font-size: 24px; margin-bottom: 24px; }
    .tm-guest__photo-bg { width: 260px; height: 300px; }
    .tm-guest__name { font-size: 24px; margin-top: 18px; }
    .tm-body__para { font-size: 14px; margin-bottom: 12px; }
    .tm-body { padding-bottom: 48px; }
    .tm-guest { padding-bottom: 48px; }
    .tm-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .tm-inner { padding-left: 16px; padding-right: 16px; }
    .tm-hero { padding-top: 51px; padding-bottom: 30px; }
    .tm-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .tm-hero__left { gap: 30px; }
    .tm-hero__title { font-size: 30px; }
    .tm-body__para { font-size: 16px; margin-bottom: 10px; }
    .tm-guest__title { font-size: 30px; margin-bottom: 20px; }
    .tm-guest__photo-bg { width: 100%; height: 386px; }
    .tm-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .tm-body { padding-bottom: 30px; }
    .tm-guest { padding-bottom: 30px; }
    .tm-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("tm-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP03_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="tm-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 03 Tarun Mehta"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="tm-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 03 Tarun Mehta thumbnail" />
      <div className="tm-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="tm-hero">
      <div className="tm-inner">
        <div className="tm-hero__grid">
          <div className="tm-hero__left">
            <h1 ref={titleRef} className="tm-hero__title">
              EP 03 | Candid conversation with Tarun MEHTA, Co-founder &amp; CEO at Ather Energy on his journey to launch a game changing Electric Scooter whilst raising $135M along the way
            </h1>
            <div ref={spotifyRef} className="tm-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/4WTMHc4LS0KvAtzQsP6HNQ?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 03 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="tm-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="tm-body">
      <div className="tm-inner">
        <p className="tm-body__para">
          In today's episode, we feature the one and only Tarun MEHTA Co-founder &amp; CEO at Ather Energy.
        </p>
        <p className="tm-body__para">
          Innovations in India typically lean towards the E-commerce &amp; service sectors with multiple start-ups springing up in these sectors over the past decade. However, there is one start-up that went against the trend and ventured into the more capital intensive sector of design &amp; manufacturing, leading the path toward decarbonized mobility in India, but also making that mobility really very cool.
        </p>
        <p className="tm-body__para">
          Ather Energy is changing the game in India, changing the game in the Indian two-wheeler market with its Ather 450x scooter which is completely electric and runs on lithium-ion batteries. Ather is in effect the Tesla of the two-wheeler mobility market in India, demonstrating that an electric bike need not compromise on its looks, range, speed, or safety.
        </p>
        <p className="tm-body__para">
          Listen in to hear the journey of Ather from 2013 to today and what is planned for the future. Tarun is candid about the secret of their success and also about policy changes that will help the industry grow faster.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="tm-guest">
      <div className="tm-inner">
        <h2 className="tm-guest__title">Our Guest</h2>
        <div>
          <div className="tm-guest__photo-bg">
            <img src={GuestImg} alt="Tarun Mehta" />
          </div>
          <p className="tm-guest__name">Tarun MEHTA</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep03TarunMehta() {
  return (
    <>
      <style>{CSS}</style>
      <div className="tm-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}